<dialog #dialog [ngClass]="{ 'open': isOpen() }">
  <div #dialogHeader class="dialog-header" id="dialogHeader" (mousedown)="onMouseDown($event)">
    <span class="dialog-header-title"><ng-content select="[dialog-header]" /></span>
    <lucide-icon name="x" (click)="closeDialog()" />
  </div>
  <div class="dialog-body">
    <ng-content select="[dialog-body]" />
  </div>
</dialog>